import { useRef, forwardRef } from 'react';
import { useRecoilValue } from 'recoil';

import { SEARCH_INPUT_HEIGHT } from '../../../constants/globalSearch';
import { LAYOUT, Variation } from '../../../types/globalSearch';

import styled from '@emotion/styled';
import { globalVariables } from '../../../designSystem/constants';

// FIXME: searchManager mrt-storage 로 이관
import SearchManager from '../SearchManager';
import SearchSuggestionContent from '../SearchSuggestionContent';
import useSearchOffers from '../hooks/apis/useSearchOffers';
import { searchTerm } from '../recoil';

const searchManager = new SearchManager();

interface Props {
  isOpen: boolean;
  variations: Variation;
  handleRef: (idx: number, node: HTMLAnchorElement) => void;
  selectedIdx: number;
}

const SearchSuggestionPopup = forwardRef<HTMLDivElement, Props>(
  ({ isOpen, variations, handleRef, selectedIdx }, ref) => {
    const searchKeyword = useRecoilValue(searchTerm);
    const { layout } = variations;
    const verticalSwiperContainerRef = useRef<HTMLDivElement | null>(null);
    const { data, isError } = useSearchOffers();
    const sections = isError ? [] : data?.sections || [];
    const hasValue = sections.length > 0;
    const hasRecentKeywords = searchManager.getRecentKeywords().length > 0 && searchKeyword === '';
    const positionTop =
      layout === LAYOUT.header ? SEARCH_INPUT_HEIGHT.medium : SEARCH_INPUT_HEIGHT.large;

    if (!isOpen || (!hasValue && !hasRecentKeywords)) {
      return null;
    }

    return (
      <Container positionTop={positionTop} ref={ref}>
        <SearchSuggestionContent
          variations={variations}
          handleRef={handleRef}
          selectedIdx={selectedIdx}
          ref={verticalSwiperContainerRef}
        />
      </Container>
    );
  }
);

SearchSuggestionPopup.displayName = 'SearchSuggestionPopup';

export default SearchSuggestionPopup;

const Container = styled.div<{ positionTop: number }>`
  position: absolute;
  top: ${({ positionTop }) => `${positionTop + 4}px`};
  width: 100%;
  max-height: 500px;
  border-radius: 4px;
  background: ${globalVariables.white}; // white
  box-shadow: 0px 0px 0px 1px #e9ecef, 0px 2px 4px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  z-index: ${globalVariables.z_popup};

  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
`;
